// extracted by mini-css-extract-plugin
export var changeIcon = "_6a-4";
export var container = "_6a-0";
export var divider = "_6a-7";
export var externalLinkIcon = "_6a-1";
export var green = "_6a-5";
export var helpCircleIcon = "_6a-3";
export var iconButton = "_6a-2";
export var red = "_6a-6";